<template>
        <div class="modal-mask" @click="$emit('close')" id="renewal-modal">
          <div class="modal" id="caseModal" tabindex="-1" role="dialog" aria-labelledby="caseModal" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
              <div class="modal-content" @click.stop>
                <div class="modal-header">
                  <div class="text-left">
                    <h3 class="modal-title">{{ renewal.date }} {{ renewal.title }}</h3>
                  </div>
                  <button type="button" class="close" @click="$emit('close')" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="body-footer">
                  <div class="modal-body">
                    <img class="casePic" :src="renewal.img" alt="">
                  </div>
                  <div class="modal-footer justify-content-start">
                      <table class="table table-bordered case-table">
                        <tr>
                            <th>使用分區</th>
                            <td>{{ renewal.usage }}</td>
                        </tr>
                        <tr>
                            <th>基地位置</th>
                            <td>{{ renewal.address }}</td>
                        </tr>
                        <tr>
                            <th>基地面積</th>
                            <td>{{ renewal.area }}</td>
                        </tr>
                        <tr>
                            <th>實施方式</th>
                            <td>{{ renewal.implementation }}</td>
                        </tr>
                        <tr>
                            <th>目前進度</th>
                            <td>{{ renewal.progress }}</td>
                        </tr>
                        <tr>
                            <th>實施者</th>
                            <td>{{ renewal.implementer }}</td>
                        </tr>
                        <tr>
                            <th>聯絡方式</th>
                            <td>{{ renewal.contact }}</td>
                        </tr>
                        <tr>
                          <th>詳細內容</th>
                          <td>
                            <div v-for="(pdf, i) in renewal.pdfs" :key="i">
                              <i class="far fa-file-pdf"></i>&nbsp;
                              <a :href="pdf.file" target="pdf" class="pdf">{{ pdf.title }}</a>
                            </div>
                          </td>
                        </tr>
                      </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
</template>

<script>

export default {
  name: 'RenewalModal',
  components: {
  },
  props: {
    renewal: Object,
  },
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.modal-title {
  font-size: 1.17em;
}
.modal-default-button {
  float: right;
}
th {
  text-align: center;
  width: 110px;
}
td {
  text-align: left;
}
.hidden {
  visibility: hidden;
}
#caseModal {
  display: block;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
}
.modal-mask.noshow {
  display: none;
}
.modal-header {
  padding-bottom: 0.5rem;
}
.modal-body {
  overflow-y: visible;
  background-color: #222;
  padding: 0;
  height: 42vh;
}
.modal-footer {
  overflow-y: auto;
  display: block;
  height: 42vh;
}
.casePic{
  width: 100%;
  height: 42vh;
}
@media (min-width: 992px) {
  .modal-dialog {
    max-width: 95%;
  }
  .modal-title {
    font-size: 1.75rem;
  }
  .modal-body {
    overflow-y: visible;
    background-color: #222;
    width: 50%;
    height: 83.1vh;
  }
  .modal-footer {
    width: 50%;
    height: 83.1vh;
  }
  .body-footer {
    display: flex;
  }
  .casePic{
    height: 83.1vh;
  }
}
.swiper-pagination >>> .swiper-pagination-bullet-active {
  background-color:  rgba(11, 109, 49, 0.842);;
}
.swiper-button-next, .swiper-button-prev {
    background-image: none;
    fill: rgba(11, 109, 49, 0.842);
}
.social-icon {
  margin-right: 4%;
}
.case-table {
  font-size: 1.3rem;
}
</style>